module.exports = __webpack_public_path__ + "media/images/pic/varia-9a31ef0e1617113962a2232b7e9755bc.jpeg";